import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { legacyNav } from '@/iframe/legacyNavState';
import { installUpdate } from '@/iframe/legacyNavActions';
import { isUpdateProposalDue } from '@/utils/domain/legacyNavModel';

// Proposes the reload once per new legacy version (legacyNav.updateReady, reset with every legacy document), the first
// time the application is not on screen. It cannot wait for the chrome: the first load after a deployment runs the
// previous legacy from its service worker cache, which has no externis.vueSession, so the session is never primed and
// the chrome stays hidden on the login page and the portal until that reload.
export function useUpdateProposal() {
	const route = useRoute();
	const due = computed(() => isUpdateProposalDue({ updateReady: legacyNav.updateReady, legacyRoute: Boolean(route.meta?.legacyView), page: legacyNav.page }));
	let proposed = false;

	watch(
		() => legacyNav.updateReady,
		(ready) => {
			if (!ready) proposed = false;
		}
	);
	watch(
		due,
		(value) => {
			if (!value || proposed) return;
			proposed = true;
			installUpdate();
		},
		{ immediate: true }
	);
}
